import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-certificate-portal',
  templateUrl: './download-certificate-portal.component.html',
  styleUrls: ['./download-certificate-portal.component.scss']
})
export class DownloadCertificatePortalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
